import React from 'react'
import './style-sheet.css';
import profilePic from '../Components/Assets/profil-pic.png';
import gitIcon from '../Components/Assets/github-mark.png';
import lIIcon from '../Components/Assets/LI-In-Bug.png';


export const About = () => {
  return (     
  
  <div className="grid">
      <div className="div-Om">
        <div className="omTitle"></div> 

        <img className="profile-pic" src={profilePic} alt="Profilbillede af Lars Schou Gregersen" />
        <div>

          <div className="omText">
            <h2>Om mig</h2>
            <p>
              Mit navn er Lars Schou Gregersen, jeg er 35 år og en engageret dansk softwareudvikler med base på Sjælland. 
              Jeg har specialiseret mig i <strong>softwareudvikling og avanceret programmering</strong> gennem en 
              <strong>Diploma of Information Technology – Advanced Programming</strong> fra TAFE Queensland i Australien. 
              Under uddannelsen har jeg arbejdet intensivt med <strong>Java, C#, JavaScript, React, Express, Python, HTML og CSS</strong> 
              samt databaser <strong>MySQL og NoSQL</strong> som MariaDB og MongoDB. Dette har givet mig erfaring med at udvikle komplette løsninger, 
              fra backend-logik og databaseintegration til moderne frontend-designs.
            </p>
            <p>
              Jeg har udviklet forskellige projekter, herunder desktop-applikationer i Java, responsive webapplikationer og databasedrevne systemer. 
              Jeg arbejder rutineret i udviklingsmiljøer som VS Code, IntelliJ, NetBeans og Visual Studio, og bruger GitHub aktivt til versionsstyring 
              og samarbejde. På min GitHub kan du se konkrete projekter, der demonstrerer mine færdigheder i objektorienteret programmering, 
              databasedesign, API-udvikling og brugergrænseflade-design.
            </p>
            <p>
              Min styrke ligger ikke kun i det tekniske, men også i min erhvervserfaring uden for IT. 
              Som tidligere selvstændig og som teamleder i detailbranchen har jeg fået værdifulde erfaringer med <strong>projektstyring, kundekontakt, teamwork og problemløsning</strong>. 
              Jeg er vant til at tage ansvar, bevare overblikket under pres og sikre, at opgaver bliver løst til tiden og i høj kvalitet. 
              Disse evner kan jeg direkte overføre til softwareudvikling, hvor struktur, samarbejde og præcision er afgørende.
            </p>
            <p>
              Jeg er kendt som mødestabil, lærevillig og resultatorienteret. Jeg motiveres af at udvikle løsninger, der ikke kun fungerer teknisk, 
              men også giver værdi for brugerne og virksomheden. Jeg ønsker nu at bruge mine kompetencer og min arbejdserfaring i en professionel 
              udviklerrolle, hvor jeg kan bidrage til virksomhedens succes og samtidig fortsætte min egen faglige udvikling.
            </p>
          </div>

          <div>
            <h2>Hvad jeg kan bidrage med</h2>
            <p>
              Jeg tilbyder en kombination af <strong>teknisk viden</strong> og <strong>praktisk erhvervserfaring</strong>. 
              Jeg kan indgå i et team, hvor jeg bidrager med softwareudvikling i både frontend og backend, arbejder med databaser og er med i hele 
              udviklingsprocessen fra planlægning til implementering og test. Jeg har erfaring med moderne frameworks og værktøjer og 
              kan hurtigt tilpasse mig nye teknologier. 
            </p>
            <p>
              Jeg brænder især for <strong>Java og databasedrevne systemer</strong>, men jeg har også stor interesse i at udvikle mig inden for webteknologier, 
              cloud-løsninger og IT-sikkerhed. Jeg trives i et miljø, hvor jeg kan bidrage aktivt, lære af erfarne kolleger og være en del af et dynamisk udviklingsteam.
            </p>
          </div>

          <div>
            <h2>Hvorfor vælge mig?</h2>
            <ul>
              <li><strong>Stærk teknisk profil:</strong> Erfaring med Java, C#, React, Python, Express, databaser og moderne værktøjer.</li>
              <li><strong>Arbejdsmoral:</strong> Stabil, ansvarsbevidst og hurtig til at lære nyt.</li>
              <li><strong>Tværfaglig erfaring:</strong> Baggrund i ledelse, kundekontakt og projektstyring.</li>
              <li><strong>Team-orienteret:</strong> Vant til at samarbejde, men også selvkørende på egne opgaver.</li>
              <li><strong>Fremtidig udvikler:</strong> Motiveret for at vokse i en professionel IT-karriere og skabe værdi for virksomheden.</li>
            </ul>
          </div>

          <div>
            <h2>Følg mig</h2>
 <div className="social-icons">
              <a href="https://github.com/LSchouG" target="_blank" rel="noopener noreferrer">
                <img src={gitIcon} alt="GitHub" />
              </a>
              <a href="https://www.linkedin.com/in/lars-schou-gregersen-18b477248/" target="_blank" rel="noopener noreferrer">
                <img src={lIIcon} alt="LinkedIn" />
              </a>
                <a href="/uploads/Lars-Gregersen-CV.pdf" download className="cv-icon">
                 CV
              </a>
            </div> 
          </div>

        </div>
      </div>
          </div>   
  )
}
